import type { UIComponent } from '~/services/layout/index.ts';
import { isEmptyArray } from '~/services/layout/layout.ts';
import { isValidUrl } from '~/utils/validations';

const OBSERVE_STORAGE_ENDPOINT_TAG = 'observe_storage';

/**
 * Whether a UI component's feed depends on remote Context Setter keys.
 *
 * Feeds tagged with `observe_storage` read user-specific values from session
 * storage populated by the Context Setter remote feed.
 *
 * @param uiComponent - UI component enriched with endpoint tags from the loader.
 * @returns `true` when the component should wait for remote client context.
 */
export function uiComponentRequiresRemoteClientContext(
  uiComponent: UIComponent
): boolean {
  const tags: string[] | null | undefined = uiComponent?._tags;

  if (!tags || isEmptyArray(tags)) return false;

  return tags.includes(OBSERVE_STORAGE_ENDPOINT_TAG);
}

export function getContextSetterRemoteUrl(contextSetter?: {
  enabled?: boolean;
  remote_url?: string;
}): string {
  if (!contextSetter?.enabled) return '';

  const contextSetterRemoteUrl: string = contextSetter.remote_url?.trim() ?? '';

  if (!isValidUrl(contextSetterRemoteUrl)) return '';

  return contextSetterRemoteUrl;
}
